import { z } from 'zod';
import { RoleSchema } from './user.js';

// What an invite/enrollment grants — deliberately a subset of the full
// Role enum: inviting someone as developer/training_admin isn't built yet
// (out of scope, see docs/ontwerp.md §7 — the same mechanism could extend
// to it later without a schema change here).
export const InviteRoleSchema = z.enum(['learner', 'tester']);
export type InviteRole = z.infer<typeof InviteRoleSchema>;

export const CreateInviteRequestSchema = z.object({
  email: z.string().email(),
  role: InviteRoleSchema,
});
export type CreateInviteRequest = z.infer<typeof CreateInviteRequestSchema>;

export const CreateInviteResponseSchema = z.object({
  inviteUrl: z.string(),
});
export type CreateInviteResponse = z.infer<typeof CreateInviteResponseSchema>;

export const AcceptInviteRequestSchema = z.object({
  password: z.string().min(8).max(200),
  displayName: z.string().min(1).max(120),
});
export type AcceptInviteRequest = z.infer<typeof AcceptInviteRequestSchema>;

export const EnrolledViaSchema = z.enum(['invite', 'domain', 'manual']);
export type EnrolledVia = z.infer<typeof EnrolledViaSchema>;

export const EnrollmentSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string(),
  roles: z.array(RoleSchema),
  enrolledVia: EnrolledViaSchema,
  createdAt: z.string().datetime(),
});
export type Enrollment = z.infer<typeof EnrollmentSchema>;

// A self-registration awaiting a training_admin/super_admin's approval.
export const PendingUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string(),
  createdAt: z.string().datetime(),
});
export type PendingUser = z.infer<typeof PendingUserSchema>;
